"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _styledComponents = require("styled-components");
var _createMixin = _interopRequireDefault(require("../utils/createMixin"));
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}
var _default = (0, _createMixin["default"])(function () {
  return (0, _styledComponents.css)(["position:absolute;width:1px;height:1px;margin:-1px;border:0;padding:0;clip-path:inset(100%);clip:rect(0 0 0 0);overflow:hidden;"]);
});
exports["default"] = _default;